import { KanbanColumn } from './KanbanColumn';

/**
 * Kanban Board Component
 * Displays proposal columns organized by status
 */
export function KanbanBoard({
  proposalsByStatus,
  statuses,
  columns,
  onProposalClick,
  onVote,
  voting,
  showVoting,
  userVotes,
}) {
  return (
    <div className="t24-kanban-board">
      {columns.map((statusKey) => {
        const proposals = proposalsByStatus[statusKey] || [];
        const statusLabel = statuses[statusKey] || statusKey;

        return (
          <KanbanColumn
            key={statusKey}
            status={statusKey}
            statusLabel={statusLabel}
            proposals={proposals}
            onProposalClick={onProposalClick}
            onVote={onVote}
            voting={voting}
            showVoting={showVoting}
            userVotes={userVotes}
          />
        );
      })}
    </div>
  );
}
